import { render, staticRenderFns } from "./PoiForm.vue?vue&type=template&id=d3137638&scoped=true"
import script from "./PoiForm.vue?vue&type=script&lang=js"
export * from "./PoiForm.vue?vue&type=script&lang=js"
import style0 from "./PoiForm.vue?vue&type=style&index=0&id=d3137638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3137638",
  null
  
)

export default component.exports